import { getScrollX, getScrollY } from '../ADNDHelpers'
import {
  extendADNDDropTarget,
  DEFAULT_PROPS as ADNDDropTarget_DEFAULT_PROPS,
  PRIVATE as ADNDDropTarget_PRIVATE
} from './ADNDDropTarget'
import { JSON_TYPE } from '../sources/ADNDDataSource'
import { getState } from '../ADNDState'
import getADNDDragLayer from '../layers/ADNDDragLayer'
import getADNDTargetsLayer from '../layers/ADNDTargetsLayer'

const ADNDDragLayer = getADNDDragLayer()
function ADNDDragLayerSkipUpdateContent() {}
const ADNDTargetsLayer = getADNDTargetsLayer()

export const PLACEHOLDER_CLASS_NAME = 'adnd-items-list-placeholder'
export const DEFAULT_PLACEHOLDER_V_MARGIN = 4

function DEFAULT_PROPS() {
  return {
    ...ADNDDropTarget_DEFAULT_PROPS(),
    items: [],
    itemBorders: [],
    lastY: null,
    focusedIndex: null,
    currentPosition: null,
    placeholderNode: null,
    placeholderHeight: 0,
    placeholderFullHeight: 0,
    minPlaceholderHeight: 0,
    onPositionChangeHandler: null,
    onUpdateItemPositionsHandler: null,
    onPlaceholderHeightChangeHandler: null,
    placeholderBuilder: null,
    placeholderVMargin: DEFAULT_PLACEHOLDER_V_MARGIN,
    started: false,
    hiddenItem: null,
    hiddenItemIndex: null,
    hiddenItemStyleDisplay: null
  }
}

const PRIVATE = {
  fetchData(state, event) {
    if (null != this.props.currentPosition) {
      if (null != state.source) {
        const data = {
          itemType: state.source.PUBLIC.getType(),
          item: state.source.PUBLIC.getData(),
          position: this.props.currentPosition,
          clone: 'clone' == state.operation.type
        }
        return [data]
      } else if (event.dataTransfer && state.item.type) {
        try {
          const eventData = JSON.parse(event.dataTransfer.getData(JSON_TYPE))
          const data = {
            itemType: state.item.type,
            item: eventData,
            position: this.props.currentPosition,
            clone: true
          }
          return [data]
        } catch {
          //
        }
      }
    }
    return null
  },
  fetchRect(scrollX = getScrollX(), scrollY = getScrollY()) {
    ADNDDropTarget_PRIVATE.fetchRect.call(this, scrollX, scrollY)
    this.PRIVATE.fetchItemBorders(scrollX, scrollY)
    return this.PRIVATE
  },
  fetchItemBorders(scrollX = getScrollX(), scrollY = getScrollY()) {
    // fetch items borders
    this.props.itemBorders = []
    if (null != this.props.rect) {
      const listTop = this.props.rect.top
      for (let i = 0; i < this.props.items.length; i++) {
        const item = this.props.items[i]
        item.PRIVATE.fetchRect(scrollX, scrollY)
        if (null != item.props.rect) {
          this.props.itemBorders.push({
            value: item.props.rect.bottom - listTop,
            locked: item.PRIVATE.isLocked ? item.PRIVATE.isLocked() : false,
            item
          })
        }
      }
      this.props.itemBorders.sort(function (a, b) {
        return a.value - b.value
      })
    }
    return this.PRIVATE
  },
  doEnter(state) {
    ADNDDropTarget_PRIVATE.doEnter.call(this, state)
    return this.PRIVATE
  },
  doLeave(state) {
    ADNDDropTarget_PRIVATE.doLeave.call(this, state)
    this.PRIVATE.doPositionChange(null)
    this.props.lastY = null
    this.props.placeholderNode = null
    this.props.placeholderHeight = 0
    this.props.placeholderFullHeight = 0
    return this.PRIVATE
  },
  doStart() {
    if (!this.props.started) {
      this.props.started = true
      this.props.currentPosition = null
      this.props.focusedIndex = null
      if (null != this.props.hiddenItem) {
        this.PRIVATE.doHideItem()
      }
    }
    return this.PRIVATE
  },
  doStop() {
    if (this.props.started) {
      if (null != this.props.hiddenItem) {
        this.PRIVATE.doShowItem()
      }
      this.props.started = false
    }
    return this.PRIVATE
  },
  doHideItem() {
    if (null != this.props.hiddenItem && this.props.started && null != this.props.hiddenItem.props.node) {
      if (null == this.props.hiddenItem.props.rect) {
        this.props.hiddenItem.PRIVATE.fetchRect()
      }
      this.props.hiddenItemStyleDisplay = this.props.hiddenItem.props.node.style.display
      this.props.hiddenItem.props.node.style.display = 'none'
      this.props.hiddenItemIndex = null
      for (let i = 0; i < this.props.itemBorders.length; i++) {
        if (this.props.itemBorders[i].item == this.props.hiddenItem) {
          this.props.hiddenItemIndex = i
          break
        }
      }
      if (null != this.props.hiddenItem.props.rect) {
        ADNDTargetsLayer.setBlackHole('hiddenItem', {
          top: this.props.hiddenItem.props.rect.top,
          height: this.props.hiddenItem.props.rect.height
        })
      }
      this.PRIVATE.doPositionChange(this.props.focusedIndex, true)
      this.PRIVATE.doUpdateItemPositions()
    }
    return this.PRIVATE
  },
  doShowItem() {
    if (null != this.props.hiddenItem && this.props.started) {
      if (null != this.props.hiddenItem.props.node) {
        this.props.hiddenItem.props.node.style.display = this.props.hiddenItemStyleDisplay
      }
      this.props.hiddenItemStyleDisplay = null
      this.props.hiddenItemIndex = null
      this.PRIVATE.doPositionChange(this.props.focusedIndex, true)
      this.PRIVATE.doUpdateItemPositions()
      ADNDTargetsLayer.removeBlackHole('hiddenItem')
    }
    return this.PRIVATE
  },
  doPositionChange(focusedIndex, force) {
    if (this.props.focusedIndex != focusedIndex || force) {
      const oldPosition = this.props.currentPosition
      const newPosition =
        null != this.props.hiddenItemIndex && null != focusedIndex && focusedIndex > this.props.hiddenItemIndex
          ? focusedIndex - 1
          : focusedIndex
      if (oldPosition != newPosition) {
        if (this.props.onPositionChangeHandler) {
          this.props.onPositionChangeHandler(
            {
              newPosition,
              oldPosition,
              hiddenItemIndex: this.props.hiddenItemIndex,
              node: this.props.node,
              dragItemUpdater: ADNDDragLayer.isActive() ? ADNDDragLayer.updateContent : ADNDDragLayerSkipUpdateContent
            },
            this.PUBLIC
          )
        }
        this.props.currentPosition = newPosition
      }
      this.props.focusedIndex = focusedIndex
      this.PRIVATE.doUpdateItemPositions()
      this.PRIVATE.updatePlaceholder()
    }
    return this.PRIVATE
  },
  doUpdateItemPositions() {
    if (this.props.started && this.props.onUpdateItemPositionsHandler) {
      this.props.onUpdateItemPositionsHandler({
        hiddenItemIndex: this.props.hiddenItemIndex,
        placeholderIndex: this.props.currentPosition
      })
    }
    return this.PRIVATE
  },
  doBuildPlaceholder() {
    const state = getState()
    const width = state.item.width
    this.props.placeholderHeight = state.item.height
      ? Math.max(state.item.height || 0, this.props.minPlaceholderHeight || 0)
      : this.props.minPlaceholderHeight
    this.props.placeholderFullHeight = this.props.placeholderHeight + (this.props.placeholderVMargin << 1)
    if (this.props.placeholderBuilder) {
      this.props.placeholderNode = this.props.placeholderBuilder(
        {
          width,
          height: this.props.placeholderHeight,
          vMargin: this.props.placeholderVMargin,
          className: PLACEHOLDER_CLASS_NAME
        },
        this.PUBLIC
      )
    } else {
      const placeholderNode = document.createElement('div')
      placeholderNode.className = PLACEHOLDER_CLASS_NAME
      placeholderNode.style.height = `${this.props.placeholderFulHeight}px`
      this.props.placeholderNode = placeholderNode
    }
    return this.PRIVATE
  },
  updatePlaceholder() {
    if (null != this.props.node) {
      if (null == this.props.focusedIndex) {
        if (null != this.props.placeholderNode && this.props.placeholderNode.parentNode == this.props.node) {
          this.props.node.removeChild(this.props.placeholderNode)
        }
        // ADNDTargetsLayer.removeBlackHole('placeholder')
      } else {
        if (null == this.props.placeholderNode) {
          this.PRIVATE.doBuildPlaceholder()
        }
        const currentBorder = this.props.itemBorders[this.props.focusedIndex]
        if (null == currentBorder) {
          // add to the end
          const lastBorder = this.props.itemBorders[this.props.itemBorders.length - 1]
          this.props.node.insertBefore(
            this.props.placeholderNode,
            (null == lastBorder ? this.props.node.firstChild : lastBorder.item.props.node.nextSibling) || null
          )
          // // set placeholder correction black hole
          // const placeholderBlackHole = {
          //   top: this.props.rect.top + (null == lastBorder ? 0 : lastBorder.value)
          // }
          // placeholderBlackHole.bottom = placeholderBlackHole.top + this.props.placeholderFullHeight
          // ADNDTargetsLayer.setBlackHole('placeholder', placeholderBlackHole)
        } else {
          // add before current item
          if (
            null == currentBorder.item.props.node ||
            (currentBorder.item.props.node && currentBorder.item.props.node.parentNode === this.props.node)
          ) {
            this.props.node.insertBefore(this.props.placeholderNode, currentBorder.item.props.node || null)
          }

          // // set placeholder correction black hole
          // const prevBorderValue = (this.props.itemBorders[this.props.focusedIndex - 1] || { value: 0 }).value
          // const itemHeight = currentBorder.value - prevBorderValue
          // if (this.props.placeholderFullHeight > itemHeight) {
          //   // shrink extra space
          //   const placeholderBlackHole = {
          //     top: this.props.rect.top + prevBorderValue + itemHeight
          //   }
          //   placeholderBlackHole.bottom = placeholderBlackHole.top + (this.props.placeholderFullHeight - itemHeight)
          //   ADNDTargetsLayer.setBlackHole('placeholder', placeholderBlackHole)
          // } else if (this.props.placeholderFullHeight < itemHeight) {
          //   // expand extra space
          //   const placeholderBlackHole = {
          //     top: this.props.rect.top + prevBorderValue + itemHeight
          //   }
          //   placeholderBlackHole.height = itemHeight - this.props.placeholderFullHeight
          //   ADNDTargetsLayer.setBlackHole('placeholder', placeholderBlackHole)
          // } else {
          //   ADNDTargetsLayer.removeBlackHole('placeholder')
          // }
        }
      }
    }
    return this.PRIVATE
  },
  hitTest(_x, y, force) {
    if (y != this.props.lastY || force) {
      if (0 == this.props.itemBorders.length) {
        this.PRIVATE.doPositionChange(0)
      } else {
        const listY = y - this.props.rect.top
        if (listY < this.props.itemBorders[0].value && !this.props.itemBorders[0].locked) {
          this.PRIVATE.doPositionChange(0)
        } else if (listY >= this.props.itemBorders[this.props.itemBorders.length - 1].value) {
          this.PRIVATE.doPositionChange(this.props.itemBorders.length)
        } else {
          if (null != this.props.focusedIndex) {
            const focusedIndexBorder = this.props.itemBorders[this.props.focusedIndex] || {
              value: Number.POSITIVE_INFINITY
            }

            if (listY < focusedIndexBorder.value) {
              // scan up
              let lastBorder = focusedIndexBorder
              for (let i = this.props.focusedIndex - 1; i >= 0; i--) {
                const thisBorder = this.props.itemBorders[i]
                if (listY >= thisBorder.value) {
                  if (!lastBorder.locked || !thisBorder.locked) {
                    this.PRIVATE.doPositionChange(i + 1)
                  }
                  break
                }
                lastBorder = thisBorder
              }
            } else {
              // scan down
              let lastBorder = focusedIndexBorder
              for (let i = this.props.focusedIndex + 1; i < this.props.itemBorders.length; i++) {
                const thisBorder = this.props.itemBorders[i]
                if (listY >= lastBorder.value && listY < thisBorder.value) {
                  if (!lastBorder.locked || !thisBorder.locked) {
                    this.PRIVATE.doPositionChange(i)
                  }
                  break
                }
                lastBorder = thisBorder
              }
            }
          } else {
            // full scan
            let lastBorder = this.props.itemBorders[0]
            for (let i = 1; i < this.props.itemBorders.length; i++) {
              const thisBorder = this.props.itemBorders[i]
              if (listY >= lastBorder.value && listY < thisBorder.value) {
                if (!lastBorder.locked || !thisBorder.locked) {
                  this.PRIVATE.doPositionChange(i)
                }
                break
              }
              lastBorder = thisBorder
            }
          }
        }
      }
      this.props.lastY = y
    }
    return this
  },
  frame(state) {
    if (this.props.started && this.props.placeholderNode && this.props.onPlaceholderHeightChangeHandler) {
      const placeholderHeight = state.item.height
        ? Math.max(state.item.height || 0, this.props.minPlaceholderHeight)
        : this.props.minPlaceholderHeight
      if (placeholderHeight != this.props.placeholderHeight) {
        this.props.onPlaceholderHeightChangeHandler({
          node: this.props.placeholderNode,
          newHeight: placeholderHeight,
          oldHeight: this.props.placeholderHeight
        })
        this.props.placeholderHeight = placeholderHeight
      }
    }
    return state
  },
  getDropEffect(operationType) {
    return null == this.props.currentPosition ? 'none' : 'move' == operationType ? 'move' : 'copy'
  }
}

const PUBLIC = {
  clone(withProps = {}, { capture = this.capture } = {}) {
    return ADNDItemsList(Object.assign({}, this.props, withProps), { capture })
  },
  addItem(item) {
    if (!this.props.items.includes(item)) {
      this.props.items.push(item)
    }
    return this.PUBLIC
  },
  removeItem(item) {
    const itemIndex = this.props.items.indexOf(item)
    if (itemIndex >= 0) {
      this.props.items.splice(itemIndex, 1)
    }
    return this.PUBLIC
  },
  onPositionChange(onPositionChangeHandler) {
    if ('function' == typeof onPositionChangeHandler) {
      this.props.onPositionChangeHandler = onPositionChangeHandler
    }
    return this.PUBLIC
  },
  onUpdateItemPositions(onUpdateItemPositionsHandler) {
    if ('function' == typeof onUpdateItemPositionsHandler) {
      this.props.onUpdateItemPositionsHandler = onUpdateItemPositionsHandler
    }
    return this.PUBLIC
  },
  onPlaceholderHeightChange(onPlaceholderHeightChangeHandler) {
    if ('function' == typeof onPlaceholderHeightChangeHandler) {
      this.props.onPlaceholderHeightChangeHandler = onPlaceholderHeightChangeHandler
    }
    return this.PUBLIC
  },
  buildPlaceholder(placeholderBuilder) {
    if ('function' == typeof placeholderBuilder) {
      this.props.placeholderBuilder = placeholderBuilder
    }
    return this.PUBLIC
  },
  hideItem(item) {
    if (this.props.hiddenItem != item) {
      if (null != this.props.hiddenItem) {
        this.PUBLIC.showItem(this.props.hiddenItem)
      }
      this.props.hiddenItem = item
      this.PRIVATE.doHideItem()
    }
    return this.PUBLIC
  },
  showItem(item) {
    if (this.props.hiddenItem == item) {
      this.PRIVATE.doShowItem()
      this.props.hiddenItem = null
    }
    return this.PUBLIC
  }
}

function ADNDItemsList(props, { capture = true } = {}) {
  const ADNDItemsList = extendADNDDropTarget(props, DEFAULT_PROPS())

  ADNDItemsList.capture = capture

  ADNDItemsList.PRIVATE.fetchData = PRIVATE.fetchData.bind(ADNDItemsList)
  ADNDItemsList.PRIVATE.fetchRect = PRIVATE.fetchRect.bind(ADNDItemsList)
  ADNDItemsList.PRIVATE.fetchItemBorders = PRIVATE.fetchItemBorders.bind(ADNDItemsList)
  ADNDItemsList.PRIVATE.doEnter = PRIVATE.doEnter.bind(ADNDItemsList)
  ADNDItemsList.PRIVATE.doLeave = PRIVATE.doLeave.bind(ADNDItemsList)
  ADNDItemsList.PRIVATE.doStart = PRIVATE.doStart.bind(ADNDItemsList)
  ADNDItemsList.PRIVATE.doStop = PRIVATE.doStop.bind(ADNDItemsList)
  ADNDItemsList.PRIVATE.doHideItem = PRIVATE.doHideItem.bind(ADNDItemsList)
  ADNDItemsList.PRIVATE.doShowItem = PRIVATE.doShowItem.bind(ADNDItemsList)
  ADNDItemsList.PRIVATE.doPositionChange = PRIVATE.doPositionChange.bind(ADNDItemsList)
  ADNDItemsList.PRIVATE.doBuildPlaceholder = PRIVATE.doBuildPlaceholder.bind(ADNDItemsList)
  ADNDItemsList.PRIVATE.doUpdateItemPositions = PRIVATE.doUpdateItemPositions.bind(ADNDItemsList)
  ADNDItemsList.PRIVATE.updatePlaceholder = PRIVATE.updatePlaceholder.bind(ADNDItemsList)
  ADNDItemsList.PRIVATE.hitTest = PRIVATE.hitTest.bind(ADNDItemsList)
  ADNDItemsList.PRIVATE.frame = PRIVATE.frame.bind(ADNDItemsList)
  ADNDItemsList.PRIVATE.getDropEffect = PRIVATE.getDropEffect.bind(ADNDItemsList)

  ADNDItemsList.PUBLIC.clone = PUBLIC.clone.bind(ADNDItemsList)
  ADNDItemsList.PUBLIC.addItem = PUBLIC.addItem.bind(ADNDItemsList)
  ADNDItemsList.PUBLIC.removeItem = PUBLIC.removeItem.bind(ADNDItemsList)
  ADNDItemsList.PUBLIC.onPositionChange = PUBLIC.onPositionChange.bind(ADNDItemsList)
  ADNDItemsList.PUBLIC.onUpdateItemPositions = PUBLIC.onUpdateItemPositions.bind(ADNDItemsList)
  ADNDItemsList.PUBLIC.onPlaceholderHeightChange = PUBLIC.onPlaceholderHeightChange.bind(ADNDItemsList)
  ADNDItemsList.PUBLIC.buildPlaceholder = PUBLIC.buildPlaceholder.bind(ADNDItemsList)
  ADNDItemsList.PUBLIC.hideItem = PUBLIC.hideItem.bind(ADNDItemsList)
  ADNDItemsList.PUBLIC.showItem = PUBLIC.showItem.bind(ADNDItemsList)

  return ADNDItemsList.PUBLIC
}

import ADNDListItem from './itemsList/ADNDListItem'

ADNDItemsList.listItem = ADNDListItem

export default ADNDItemsList
